import React, { useEffect, useState } from 'react'

export const ULULE_URL = 'https://fr.ulule.com/les-runes-ancestrales-tome-3-la-rune-fragmentee'

const DISMISS_KEY = 'ulule-button-dismissed'
const DELAY_MS = 3000

function isDismissed () {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === '1'
  } catch {
    return false
  }
}

// Bouton flottant discret vers la campagne Ulule : apparaît après 3 s, refermable pour la session.
export default function UluleButton () {
  const [mounted, setMounted] = useState(false)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (isDismissed()) return
    const timer = setTimeout(() => {
      setMounted(true)
      // laisse le navigateur peindre l'état initial avant la transition
      requestAnimationFrame(() => requestAnimationFrame(() => setVisible(true)))
    }, DELAY_MS)
    return () => clearTimeout(timer)
  }, [])

  const dismiss = () => {
    setVisible(false)
    try {
      sessionStorage.setItem(DISMISS_KEY, '1')
    } catch {}
    setTimeout(() => setMounted(false), 500)
  }

  if (!mounted) return null

  return (
    <div
      className={'fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 flex items-stretch bg-dark text-light border-2 border-[#c9a26b] rounded-sm shadow-[0_8px_24px_rgba(0,0,0,0.45)] transition-all duration-500 ease-out motion-reduce:transition-opacity ' +
        (visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none')}
    >
      <a
        href={ULULE_URL}
        target='_blank'
        rel='noopener noreferrer'
        className='group flex items-center gap-2.5 font-Noto px-4 sm:px-5 py-2.5 font-semibold text-sm md:text-base whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-4 focus-visible:outline-light'
      >
        <svg className='w-5 h-5 shrink-0 text-[#c9a26b]' viewBox='0 0 24 24' fill='currentColor' aria-hidden='true'>
          <path d='M12 0A11.992 11.992 0 001.676 5.884l-.822-.822a.499.499 0 00-.707 0A.5.5 0 000 5.416V12c0 6.627 5.372 12 12 12 6.627 0 12-5.373 12-12V5.416a.5.5 0 00-.854-.354l-.823.822A11.992 11.992 0 0012 0zM6.814 7.626a5.526 5.526 0 014.971 3.095 2.739 2.739 0 00.13 3.754.122.122 0 00.17 0 2.738 2.738 0 00.13-3.754 5.526 5.526 0 015.411-3.077c2.702.214 4.876 2.410 5.064 5.113a5.528 5.528 0 01-10.419 2.944.304.304 0 00-.542 0 5.528 5.528 0 01-10.420-2.944c.189-2.703 2.363-4.900 5.064-5.113.148-.012.295-.018.440-.018zm-.42 1.22a3.501 3.496 0 00-.235.008c-.013.16-.116.262-.248.388l-.052.05c-.117.113-.335.323-.333.7a.875.875 0 00.856.858c.485-.003.88-.383.882-.85.002-.325-.137-.523-.347-.722-.143-.13-.289-.281-.308-.422a3.501 3.496 0 00-.214-.01zm11.211 0a3.501 3.495 0 00-.235.008c-.013.16-.117.262-.249.388l-.051.05c-.118.113-.336.323-.334.7a.875.875 0 00.856.858c.485-.003.88-.383.882-.85.002-.325-.136-.523-.347-.723-.143-.13-.288-.28-.307-.42a3.501 3.495 0 00-.215-.011zM6.093 8.860a3.501 3.496 0 00-3.200 3.480 3.501 3.496 0 003.502 3.496 3.501 3.496 0 003.500-3.496 3.501 3.496 0 00-3.033-3.460 2.393 2.393 0 11-2.860 2.362A2.386 2.386 0 016.093 8.860zm11.816 0a2.386 2.386 0 012.088 2.382 2.391 2.391 0 11-4.784-.033 2.393 2.393 0 011.920-2.328 3.501 3.495 0 00-3.030 3.460 3.501 3.495 0 003.502 3.495 3.501 3.495 0 003.501-3.496 3.501 3.495 0 00-3.197-3.480Z' />
        </svg>
        Soutenir le tome 3 sur Ulule
        <svg className='w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
          <path d='M7 17 17 7' />
          <path d='M7 7h10v10' />
        </svg>
      </a>
      <button
        type='button'
        onClick={dismiss}
        aria-label='Masquer le bouton Ulule'
        className='flex items-center justify-center px-2.5 border-l-2 border-[#c9a26b]/40 text-light/70 hover:text-light hover:bg-white/5 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-4 focus-visible:outline-light transition-colors'
      >
        <svg className='w-4 h-4' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
          <path d='M18 6 6 18' />
          <path d='m6 6 12 12' />
        </svg>
      </button>
    </div>
  )
}
